var _circle, _circle2, _ellipse, _ellipse2, _g, _path, _path2, _path3, _circle3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 219,
    viewBox: "0 0 185 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "#8FACCF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "url(#paint0_linear_11_1158)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 72,
    width: 103,
    height: 147
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4999,
    cy: 98.5663,
    rx: 27.5893,
    ry: 26.5663,
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5,
    cy: 174.723,
    rx: 51.5,
    ry: 44.2771,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1158)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.0401,
    cy: 105.208,
    rx: 85.067,
    ry: 81.9127,
    fill: "#E9E4D4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 158.5C118.748 159.478 115.094 159.483 108.5 158.5L117 161.5L125 158.5Z",
    fill: "#32477A",
    stroke: "#4763AC",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 185H83.0017C83.3272 167.765 89.1373 152.238 89.1373 152.238H95.6057L95.6179 152.26C95.8608 152.947 102.679 168.119 103 185Z",
    fill: "#4763AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 137C83 137 87.7623 151.667 88.9776 151.982C90.1903 152.297 95.188 152.348 95.9012 151.982C96.6144 151.616 101.457 138.414 101.887 137C100.776 136.999 91.8881 141.571 91.8881 141.571L83 137Z",
    fill: "#32477A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 163.5,
    r: 0.5,
    fill: "#4763AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 158.5V167.5L117 171.5L125 167.5V158.5",
    stroke: "#4763AC",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1158",
    x1: 93,
    y1: -40,
    x2: 92.5,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426985,
    stopColor: "#25374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768372,
    stopColor: "#547BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/Department Icon.b96274b1801192f1c6d399e20b897b06.svg";
export { ForwardRef as ReactComponent };